import { RandomCompany } from '../types/randomCompanies';

export const fetchFromScrapeRaw = async (domains: string[]): Promise<RandomCompany[]> => {
  const companies: RandomCompany[] = [];
  
  for (const domain of domains) {
    try {
      const response = await fetch(`https://cache.featrix.com/scrape-raw/${domain}`);
      
      if (!response.ok) {
        console.warn(`Failed to fetch data for ${domain}: ${response.status}`);
        continue;
      }
      
      const data = await response.json();
      const companyData = data[0];
      
      if (companyData) {
        const summary = companyData['llm-json-summary'] || {};
        companies.push({
          id: `scraped-${Date.now()}-${domain}`,
          name: domain,
          domain: domain,
          business_name: summary.business_name || domain,
          business_description: summary.business_description || '',
          business_key_features: summary.business_key_features?.slice(0, 3) || [],
          logistics: summary.business_is_logistics_related || false,
          packaging: summary['sub-packaging'] ? true : false,
          d2c: summary.business_is_d2c || false,
          b2b: summary.business_is_b2b || false,
          b2c: summary.business_is_b2c || false,
          is_operating: summary.is_operating !== false,
          is_parked: summary.is_parked === true
        });
      }
    } catch (error) {
      console.error(`Error fetching data for ${domain}:`, error);
    }
  }
  
  return companies;
};

export const fetchFromRandomCompanies = async (keywords: string): Promise<RandomCompany[]> => {
  try {
    const response = await fetch(`https://cache.featrix.com/random-companies/${encodeURIComponent(keywords)}`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch companies: ${response.status}`);
    }
    
    const data = await response.json();
    
    return data.map((company: any, index: number) => {
      const summary = company['llm-json-summary'] || {};
      return {
        id: `random-${Date.now()}-${index}`,
        name: company.domain || 'Unknown Company',
        domain: company.domain,
        business_name: summary.business_name || company.domain,
        business_description: summary.business_description || '',
        business_key_features: summary.business_key_features?.slice(0, 3) || [],
        logistics: summary.business_is_logistics_related || false,
        packaging: summary['sub-packaging'] ? true : false,
        d2c: summary.business_is_d2c || false,
        b2b: summary.business_is_b2b || false,
        b2c: summary.business_is_b2c || false,
        is_operating: summary.is_operating !== false,
        is_parked: summary.is_parked === true
      };
    });
  } catch (error) {
    console.error('Error fetching random companies:', error);
    throw error;
  }
}; 